module.exports = __webpack_public_path__ + "static/duckhamper-21aa0ddcd769f144ccbb297f161f8b48.jpeg";